import React from "react";
import Update from "../../../../../../images/icons/upate-icon1.png";

/**
 * UpdateButton Component
 * Reusable update button with loading state
 */
const UpdateButton = ({
  isLoading,
  disabled,
  isTimeInputActive,
  onClick,
  type = "submit",
  className = "set-button",
}) => {
  if (isTimeInputActive) return null;

  return (
    <div className="set-btn-outer">
      <button
        type={type}
        className={className}
        disabled={disabled || isLoading || isTimeInputActive ? "disabled" : undefined}
        onClick={isLoading ? undefined : onClick}
        style={{
          pointerEvents: isLoading ? "none" : "auto",
          cursor: isLoading ? "default" : "pointer",
          opacity: isLoading ? 0.7 : 1,
        }}
      >
        {isLoading ? (
          <div
            style={{
              width: "18px",
              height: "18px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "4px",
              animation: "pulse 1.5s ease-in-out infinite",
            }}
          />
        ) : (
          <img width="18" src={Update} alt="update" />
        )}
      </button>
    </div>
  );
};

export default UpdateButton;
